import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import CustomButton from '../components/styled/CustomButton'
import PromotionImage from '../assets/imgs/profile-screen-images/PromotionImage.svg'
import Calender from '../components/styled/Calender'
import { Button } from '@mui/material'
import ServiceCard from '../components/ServiceCard'
import ConfirmedMessageModal from './ConfirmedMessage'
import ScheduledCardImage from '../assets/imgs/dashboard/scheduledCard.png'
import StarIcon from '@mui/icons-material/Star'
import ServicesCard from '../components/Cards/ServicesCard'
import moment from 'moment'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  width: '470px',
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const ConfirmReservationModal = ({
  handleConfirmReservationModal,
  modalOpen = false,
  booking,
}) => {
  const [confimedMessageModal, setConfimedMessageModal] = React.useState(false)
  const handleConfirmedMessageModal = () => {
    if (modalOpen) {
      handleConfirmReservationModal(false)
    }
    setConfimedMessageModal(!confimedMessageModal)
  }

  return (
    <>
      <Modal
        open={modalOpen}
        onClose={() => handleConfirmReservationModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="text-center confirm-reservation">
            <h3 className="fs-24 mb-3 fw-bold">
              {moment(booking?.date).format('Do MMM, YYYY')}
            </h3>
            <ServicesCard booking={booking} isNewBooking={true} handleConfirmReservationModal={handleConfirmReservationModal} />
          </div>
        </Box>
      </Modal>
      {confimedMessageModal && (
        <ConfirmedMessageModal
          handleConfirmedMessageModal={handleConfirmedMessageModal}
          modalOpen={confimedMessageModal}
        />
      )}
    </>
  )
}

export default ConfirmReservationModal
